<template>
  <ValidationProvider :name="label" :rules="rules" :vid="vid" v-slot="validationContext">
    <b-form-group :label-for="labelFor">
      <template v-slot:label>{{ label }}</template>
      <slot :state="getValidationState(validationContext)"></slot>
      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
  import { BFormGroup, BFormInvalidFeedback } from 'bootstrap-vue';
  import { ValidationProvider } from 'vee-validate';

  export default {
    name: 'EwnFormControl',
    components: {
      BFormGroup,
      BFormInvalidFeedback,
      ValidationProvider
    },
    props: {
      label: {
        type: String,
        required: true
      },
      labelFor: {
        type: String
      },
      rules: {
        type: Object
      },
      vid: {
        type: String
      }
    },
    methods: {
      getValidationState ({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      }
    }
  };
</script>

<style lang="scss" scoped>
  ::v-deep .form-group {
    margin-bottom: 12px;
  }
</style>
